export default __webpack_public_path__ + "static/media/default_user.8fcc949c.svg";